import React, { Component } from "react";
import PropTypes from "prop-types";
import ControlTitle from "../ControlTitle";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import { Icon, Button } from "semantic-ui-react";
import _ from "lodash";
var resizeImage = require("resize-image");

class PhotoControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUri: "",
      imageRatio: 1,
      base64: "",
      response: "",
      rotation: 0,
      annotate: false
    };
    this.width = 315;
  }

  componentDidMount() {
    if (this.props.element_value !== "") {
      if (this.props.element_value.indexOf("data:") !== -1) {
        this.setState({ base64: this.props.element_value });
      }
    }
  }

  deletePhoto() {
    this.setState({
      imageUri: "",
      imageRatio: 1,
      base64: "",
      response: "",
      rotation: ""
    });

    this.forceUpdate();
    this.props.onChange(
      this.props.repeatingForm,
      this.props.element_id,
      "/jpeg",
      this.props.element_value,
      true
    );
  }

  renderImage() {
    const { validate, error } = this.props;

    if (this.state.base64 !== "") {
      return (
        <div style={{ maxWidth: 315, position: "relative" }}>
          <Icon
            color="#e6e6e6"
            size="big"
            onClick={this.deletePhoto.bind(this)}
            inverted
            style={{
              cursor: "pointer",
              position: "absolute",
              right: 5,
              top: 10,
              zIndex: 10
            }}
            name="remove circle"
          />
          <img
            width={this.width}
            style={{ borderRadius: 4.57142864 }}
            src={this.state.base64}
          />
        </div>
      );
    }

    if (validate && error && this.state.imageUri === "") {
      return (
        <div
          style={{
            backgroundColor: "#e6e6e6",
            border: "2px solid #e0b4b4",
            textAlign: "center",
            verticalAlign: "middle",
            borderRadius: 4.57142864,
            marginTop: 7,
            marginBottom: 0,
            marginLeft: 0,
            maxWidth: this.width,
            height: (180 / 315) * this.width
          }}
        >
          <i
            style={{ top: "60px", position: "relative", color: "white" }}
            class="huge image icon"
          ></i>
        </div>
      );
    }

    if (this.state.imageUri !== "") {
      let x = this.width * this.state.imageRatio;
      return (
        <div style={{ maxWidth: 315, position: "relative" }}>
          <Icon
            reverseColor="white"
            underlayColor="transparent"
            onPress={this.deletePhoto.bind(this)}
            containerStyle={{
              position: "absolute",
              right: 0,
              top: 10,
              zIndex: 10,
              padding: 10
            }}
            type="material-community"
            name="close-circle"
            color={"#e6e6e6"}
            size={this.width === 150 ? 22 : 32}
          />
          <image
            style={{ width: this.width, height: x, borderRadius: 4.57142864 }}
            source={this.state.imageUri}
          />
        </div>
      );
    }

    if (validate && error) {
      return (
        <div
          style={{
            backgroundColor: "#e6e6e6",
            border: "2px solid #e0b4b4",
            textAlign: "center",
            verticalAlign: "middle",
            borderRadius: 4.57142864,
            marginTop: 7,
            marginBottom: 0,
            marginLeft: 0,
            maxWidth: this.width,
            height: (180 / 315) * this.width
          }}
        >
          <i
            style={{ top: "60px", position: "relative", color: "white" }}
            class="huge image icon"
          ></i>
        </div>
      );
    }

    return (
      <div
        style={{
          backgroundColor: "#e6e6e6",
          textAlign: "center",
          verticalAlign: "middle",
          borderRadius: 4.57142864,
          marginTop: 7,
          marginBottom: 0,
          marginLeft: 0,
          maxWidth: this.width,
          height: (180 / 315) * this.width
        }}
      >
        <i
          style={{ top: "60px", position: "relative", color: "white" }}
          class="huge image icon"
        ></i>
      </div>
    );
  }

  handleSelect() {
    this.refs["selectedFile"].click();
  }

  fileSelectedHandler(e) {
    if (e.target.files.length > 0) {
      const {
        onChange,
        repeatingForm,
        element_id,
        ...formControl
      } = this.props;

      var _URL = window.URL || window.webkitURL;

      var file = e.target.files[0];
      let fileurl = _URL.createObjectURL(file);
      const scope = this;
      var img = new Image();
      img.onload = function() {
        let newWidth = img.width;
        let newHeight = img.height;
        switch (formControl.element_params.W.toString()) {
          case "1":
            if (newHeight > newWidth) {
              newWidth = 240;
              newHeight = 320;
            } else {
              newWidth = 320;
              newHeight = 240;
            }
            break;
          case "2":
            if (newHeight > newWidth) {
              newWidth = 478;
              newHeight = 640;
            } else {
              newWidth = 640;
              newHeight = 478;
            }
            break;
          case "3":
            if (newHeight > newWidth) {
              newWidth = 956;
              newHeight = 1280;
            } else {
              newWidth = 1280;
              newHeight = 956;
            }
            break;
          default:
            break;
        }

        var resized = resizeImage.resize(
          img,
          newWidth,
          newHeight,
          resizeImage.JPEG
        );
        scope.setState({ base64: resized });
        onChange(repeatingForm, element_id, resized);
      };
      img.src = fileurl;
    }
  }

  handleClosePhoto() {
    this.setState({ response: "", rotation: "", annotate: false });
  }
  render() {
    const { element_prompt, element_optional } = this.props;

    let optional = element_optional;
    if (optional === undefined) {
      optional = "1";
    }

    return (
      <div>
        <ControlTitle
          text={element_prompt}
          optional={optional === "1" ? true : false}
        ></ControlTitle>
        {this.renderImage()}
        <br></br>
        <div>
          <input
            onChange={this.fileSelectedHandler.bind(this)}
            type="file"
            ref="selectedFile"
            style={{ display: "none" }}
          />
          <Button
            className="ui active button"
            role="button"
            onClick={this.handleSelect.bind(this)}
          >
            Select Photo
          </Button>
        </div>
        <br />
      </div>
    );
  }
}

PhotoControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  element_id: PropTypes.number,
  element_value: PropTypes.string
};

const mapStateToProps = state => ({
  imageQueue: state.informedWebApp.imageQueue,
  actionQueue: state.informedWebApp.actionQueue,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  draftId: state.form.draftId
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhotoControl);



// WEBPACK FOOTER //
// ./src/components/PhotoControl/index.js